'use client';

import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Box } from '@mui/material';
import { Button } from '@prismo-io/design-system';
import { useMe } from '@prismo-io/feature-auth/providers/me';
import { Application, translate } from '@prismo-io/router';
import { LanguageCode, type LanguageCodeT } from '@prismo-io/schemas';
import Link from 'next/link';
import type { FC } from 'react';

type Props = {
  containedBtn?: boolean;
  userUrl: string;
};

const buildHelioUrl = (locale: LanguageCodeT) => {
  // eslint-disable-next-line no-constant-condition, prettier/prettier
  return translate({
    app: Application.HELIO,
    path: '/avant-de-commencer',
    addHostname: true,
    locale,
  });
};

export const RetakeQuestionnaireBtn: FC<Props> = (props) => {
  const { containedBtn = false, userUrl } = props;

  const { i18n } = useLingui();
  const { locale = LanguageCode.Enum.fr } = i18n;
  const auraUrl = buildHelioUrl(locale as LanguageCodeT);

  const me = useMe();

  const isMe = me && me.url === userUrl;

  if (!isMe) return null;

  return (
    <Button
      LinkComponent={Link}
      href={auraUrl}
      variant={containedBtn ? 'contained' : 'outlined'}
      color={containedBtn ? 'gradient' : 'primary'}
    >
      <Box component="span" display={{ none: 'inline', md: 'none' }}>
        <Trans>Repasser</Trans>
      </Box>
      <Box component="span" display={{ none: 'none', md: 'inline' }}>
        <Trans>Repasser Helio</Trans>
      </Box>
    </Button>
  );
};
